import { Heading, List, Stack, Text } from '@chakra-ui/react'
import { MemberLayout, PageTitle } from '~/components/member/layout'
import { useT } from '~/i18n/use-t'

/** /cookies: the three strictly necessary cookies, so no banner is needed. */
export default function Cookies() {
  const { t } = useT()
  return (
    <MemberLayout backTo='/join' backHistory>
      <PageTitle title={t('cookies.title')} subtitle={t('cookies.intro')} />
      <Stack gap={3} as='section'>
        <Heading as='h2' size='xl'>
          {t('cookies.listTitle')}
        </Heading>
        <List.Root ps={6} gap={2} aria-label={t('cookies.listTitle')}>
          <List.Item>{t('cookies.member')}</List.Item>
          <List.Item>{t('cookies.registration')}</List.Item>
          <List.Item>{t('cookies.admin')}</List.Item>
        </List.Root>
        <Text>{t('cookies.none')}</Text>
      </Stack>
      <Stack gap={3} as='section'>
        <Heading as='h2' size='xl'>
          {t('cookies.storageTitle')}
        </Heading>
        <Text>{t('cookies.storage')}</Text>
        <Text>{t('cookies.theme')}</Text>
      </Stack>
    </MemberLayout>
  )
}
